import React from 'react';
import CommonPageHeader from '../../../components/CommonPageHeader/CommonPageHeader';
import PageHelmet from '../../../components/shared/PageHelmet';
import MainFooter from '../../../components/MainFooter/MainFooter';
import NavHeader from '../../../components/NavHeader/NavHeader';
import KeyFeatures from '../KeyFeatures/KeyFeatures';
import OurApproach from '../../Home/OurApproach/OurApproach';
import AdditionalServices from '../AdditionalServices/AdditionalServices';
import { Search, Target, Share2, TrendingUp, MapPin, PenTool, UserPlus, BarChart3, FlaskConical, FileText } from 'lucide-react';
import OurExpertise from '../../../components/OurExpertise/OurExpertise';
import { Link } from 'react-router-dom';

const OurExpertiseData = [
    {
        id: 1,
        title: "SEO & Local SEO",
        icon: <Search size="64" strokeWidth='1' />,
        content: "Technical, content, and local SEO that improves your visibility for the searches that matter to your business."
    },
    {
        id: 2,
        title: "Google Ads & Performance Marketing",
        icon: <Target size="64" strokeWidth='1' />,
        content: "Google Ads campaigns and performance marketing built around measurable return on ad spend."
    },
    {
        id: 3,
        title: "Social Media & Content Marketing",
        icon: <Share2 size="64" strokeWidth='1' />,
        content: "Social media and content marketing that builds an audience and drives qualified traffic."
    },
    {
        id: 4,
        title: "Lead Generation & Conversion Optimization",
        icon: <TrendingUp size="64" strokeWidth='1' />,
        content: "Lead generation campaigns paired with conversion rate optimization to turn traffic into customers."
    }
]

const KeyFeaturesData = [
    {
        id: 1,
        title: "SEO",
        icon: <Search size="42" strokeWidth='1' />,
        content: "On-page, technical, and content SEO to grow organic search visibility."
    },
    {
        id: 2,
        title: "Local SEO",
        icon: <MapPin size="42" strokeWidth='1' />,
        content: "Local search and map-pack optimization for location-based businesses."
    },
    {
        id: 3,
        title: "Google Ads",
        icon: <Target size="42" strokeWidth='1' />,
        content: "Search and display campaigns managed for measurable ROI."
    },
    {
        id: 4,
        title: "Social Media Marketing",
        icon: <Share2 size="42" strokeWidth='1' />,
        content: "Organic and paid social strategies that build audience and engagement."
    },
    {
        id: 5,
        title: "Content Marketing",
        icon: <PenTool size="42" strokeWidth='1' />,
        content: "Content that attracts, informs, and converts your target audience."
    },
    {
        id: 6,
        title: "Lead Generation",
        icon: <UserPlus size="42" strokeWidth='1' />,
        content: "Campaigns designed to generate qualified leads for your sales team."
    },
    {
        id: 7,
        title: "Analytics & Conversion Optimization",
        icon: <TrendingUp size="42" strokeWidth='1' />,
        content: "Data-driven analytics and CRO that improve results over time."
    }
]

const AdditionalServicesData = [
    {
        id: 1,
        title: "Analytics Setup",
        icon: <BarChart3 size="54" strokeWidth='1' />,
        content: "Proper tracking and analytics setup so every decision is backed by data."
    },
    {
        id: 2,
        title: "A/B Testing & CRO",
        icon: <FlaskConical size="54" strokeWidth='1' />,
        content: "Structured experimentation that steadily improves conversion rates."
    },
    {
        id: 3,
        title: "Monthly Reporting",
        icon: <FileText size="54" strokeWidth='1' />,
        content: "Clear, regular reporting that shows exactly what's working."
    }
]

const OurApproachData = [
    {
        id: 1,
        title: <h3><Link to="/">Discovery</Link></h3>,
        img: "assets/img/project/discover_icon_white.svg",
        content: "Understand your goals through collaborative sessions."
    },
    {
        id: 2,
        title: <h3><Link to="/">Design</Link></h3>,
        img: "assets/img/project/design_icon_white.svg",
        content: "Deliver wireframes, prototypes, and scalable architectures focused on usability and performance."
    },
    {
        id: 3,
        title: <h3><Link to="/">Development</Link></h3>,
        img: "assets/img/project/develop_icon_white.svg",
        content: "Deliver wireframes, prototypes, and scalable architectures focused on usability and performance."
    },
    {
        id: 4,
        title: <h3><Link to="/">Quality Assurance</Link></h3>,
        img: "assets/img/project/define_icon_white.svg",
        content: "Ensure flawless functionality on all devices and platforms."
    },
    {
        id: 5,
        title: <h3><Link to="/">Launch & Support</Link></h3>,
        img: "assets/img/project/deliver_icon_white.svg",
        content: "Seamless deployment, app store submissions, and ongoing maintenance."
    }
]
const bgColors = ["#006ce0", "#001133", "#006ce0", "#001133", "#006ce0"];

const DigitalMarketingSEO = () => {
    return (
        <>
            <PageHelmet
                pageTitle="Digital Marketing & SEO"
                description="Harsoft Solutions offers digital marketing & SEO services — SEO, local SEO, Google Ads, social media marketing, content marketing, and lead generation."
                keywords="Digital Marketing, SEO, Local SEO, Google Ads, Social Media Marketing, Lead Generation"
                path="/digital-marketing-seo"
            />

            <NavHeader />
            <main>
                <CommonPageHeader title="Digital Marketing & SEO" subtitle="Digital Marketing & SEO" />
                <OurExpertise OurExpertiseData={OurExpertiseData} title="Our Expertise" subtitle="Grow Your Audience and Your Pipeline" content="Our digital marketing & SEO services cover SEO and local SEO, Google Ads, social media and content marketing, and lead generation — all backed by analytics and conversion optimization." />
                <KeyFeatures KeyFeaturesData={KeyFeaturesData} />
                <AdditionalServices AdditionalServicesData={AdditionalServicesData} img="assets/img/expart/expart-2.jpg" />
                <OurApproach OurApproachData={OurApproachData} title="Our Process" bgColors={bgColors} />
            </main>
            <MainFooter />
        </>
    );
};

export default DigitalMarketingSEO;
